import WebsocketTerminal from './websocket-terminal.vue'
WebsocketTerminal.install = function (Vue) {
  Vue.component(WebsocketTerminal.name, WebsocketTerminal);
};
export default WebsocketTerminal



// WEBPACK FOOTER //
// ./src/omnis-business/websocket-terminal/index.js